import { queryOptions } from '@tanstack/react-query';

import {
  loadEntitiesByClassification,
  loadEntityById,
  loadMatchAtGlanceById,
  loadEntityFromTagName,
  loadWebContainerEntities,
} from '@apis/editorial';
import type { EditorialContent } from '@cobalt/utilities';

export const getEditorialsQuery = (articleFilters: Record<string, any>, language?: string) =>
  queryOptions({
    queryKey: ['editorials', articleFilters, language],
    queryFn: ({ signal }) => loadEntitiesByClassification(articleFilters, language, signal),
  });

export const getEditorialByIdQuery = (articleId: string) =>
  queryOptions({
    queryKey: ['editorial', articleId],
    queryFn: ({ signal }) => loadEntityById(articleId, signal),
    enabled: !!articleId,
  });

export const getMatchAtGlanceByIdQuery = (articleId: string) =>
  queryOptions({
    queryKey: ['match-at-glance', articleId],
    queryFn: ({ signal }) => loadMatchAtGlanceById(articleId, signal),
    enabled: !!articleId,
  });

export const getEditorialByTagQuery = (tag: string, language?: string) =>
  queryOptions({
    queryKey: ['editorials', tag, language],
    queryFn: ({ signal }) => loadEntityFromTagName(tag, language, signal),
    enabled: !!tag,
  });

export const getWebContainerQuery = (webContainerId: string, language?: string) =>
  queryOptions({
    queryKey: ['web-container', webContainerId, language],
    queryFn: ({ signal }) => loadWebContainerEntities(webContainerId, language, signal),
    placeholderData: [],
  });

export const getPhotogalleryQuery = ({ id, tagName }: { id?: string; tagName?: string }, limit?: number) =>
  queryOptions({
    ...(tagName ? getEditorialByTagQuery(tagName) : getEditorialByIdQuery(id)),
    queryKey: ['photogallery', tagName, id],
    select: (data) => (limit ? data.photos.slice(0, limit) : data.photos),
    placeholderData: { photos: [] } as EditorialContent,
    enabled: !!id || !!tagName,
  });

export const getPhotogalleryByIdQuery = (photogalleryId: string, limit?: number) =>
  getPhotogalleryQuery({ id: photogalleryId }, limit);

export const getPhotogalleryByTagQuery = (tag: string, limit?: number) => getPhotogalleryQuery({ tagName: tag }, limit);

export const getLiveblogByIdQuery = (blogId: string) =>
  queryOptions({
    queryKey: ['liveblog', blogId],
    queryFn: ({ signal }) => loadEntityById(blogId, signal),
    enabled: !!blogId,
  });
